import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h-container__header"
}
const _hoisted_2 = {
  key: 1,
  class: "h-container__header_line"
}
const _hoisted_3 = { class: "h-container__content" }
const _hoisted_4 = {
  key: 0,
  class: "h-container__content_table-wrapper"
}
const _hoisted_5 = {
  key: 1,
  class: "h-container__footer"
}

import {useSlots} from "vue";
  import { useRouter } from "vue-router";
  interface Props {
    // 标题
    title?: string;
    // 是否带有返回
    isBack?: boolean;
    // 是否是包含table表格，默认false（此配置为了解决element-ui中table宽度问题）
    isTable?: boolean;
    // 是否是无框模式，默认false
    frameless?: boolean;
    // 是否是自定义返回按钮
    backFn?: any;

  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title: {},
    isBack: { type: Boolean, default: false },
    isTable: { type: Boolean, default: false },
    frameless: { type: Boolean, default: false },
    backFn: {}
  },
  setup(__props: any) {

  const router = useRouter();
  const solts = useSlots();

  const props = __props;

  /**
   * @description 返回
   */
  const back = (): void => {
    if (props.backFn && props.backFn instanceof Function) {
      props.backFn();
    } else if (router) {
      router.back();
    } else {
      window.history.back();
    }
  }


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["h-container", {'frameless': _ctx.frameless}])
  }, [
    ((_ctx.$slots.header || _ctx.isBack || _ctx.title) && !_ctx.frameless)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.$slots.header)
            ? _renderSlot(_ctx.$slots, "header", { key: 0 })
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.isBack)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "h-container__header_back",
                      onClick: back
                    }, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        link: ""
                      }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createElementVNode("span", { class: "iconfont icon-zuojiantou_huaban" }, null, -1),
                          _createTextVNode("返回")
                        ])),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isBack && _ctx.title)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                  : _createCommentVNode("", true),
                (_ctx.title)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "h-container__header_title",
                      style: _normalizeStyle(!_ctx.isBack ? 'font-weight: 600' : '')
                    }, _toDisplayString(_ctx.title), 5))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "extra-header")
              ], 64))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isTable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default")
          ]))
        : _renderSlot(_ctx.$slots, "default", { key: 1 })
    ]),
    (_ctx.$slots.footer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "footer")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})